import { all, takeLatest, put, takeEvery } from 'redux-saga/effects';
import {
    setTimerValueSuccess,
    setTimerOutSuccess,
    startHatchGameSuccess,
    answerHatchQuestionSuccess,
    shareChallengeCalendarSuccess,
    claerHatchDataSucess
} from './action';
import {
    requestHatchGameStart,
    requestHatchQuestionAnswer,
    requestShareChallengeCalendar
} from './api';

import {
    SET_HATCH_TIMER_VALUE,
    SET_HATCH_TIMER_OUT,
    START_HATCH_GAME,
    ANSWER_HATCH_QUESTION,
    SHARE_CHALLENGE_CALENDAR,
    CLEAR_HATCHGAME_DATA
} from './constants';
import { setEventSoundSuccess } from './action';
import { SET_CALENDAR_EVENT_AUDIO_VALUE } from './constants';

function* clearHetchData( actionObj ) {
    yield put( claerHatchDataSucess( actionObj.val ) );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val: *, type: string}>>}
 */
function* getTimerValue( actionObj ) {
    yield put( setTimerValueSuccess( actionObj.val ) );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val: *, type: string}>>}
 */
function* getTimerOut( actionObj ) {
    yield put( setTimerOutSuccess( actionObj.val ) );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{gameData: *, type: string}>>}
 */
function* startHatchGame( actionObj ) {
    const gameData = yield requestHatchGameStart( actionObj.hatchID, actionObj.country, actionObj.resolve );
    if ( gameData ) {
        yield put( startHatchGameSuccess( gameData ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{answerData: *, type: string}>>}
 */
function* answerHatchQuestion( actionObj ) {
    const answerData = yield requestHatchQuestionAnswer( actionObj.hatchID, actionObj.gameID, actionObj.answerObj );
    if ( answerData ) {
        yield put( answerHatchQuestionSuccess( answerData ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{challengeData: *, type: string}>>}
 */
function* shareChallengeCalendar( actionObj ) {
    const challengeData = yield requestShareChallengeCalendar( actionObj.id, actionObj.hatchID, actionObj.shareableType );
    if ( challengeData ) {
        yield put( shareChallengeCalendarSuccess( challengeData ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchTimerValue() {
    yield  takeLatest( SET_HATCH_TIMER_VALUE, getTimerValue );
    yield  takeLatest( SET_HATCH_TIMER_OUT, getTimerOut );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchGameProgress() {
    yield  takeLatest( START_HATCH_GAME, startHatchGame );
    yield  takeLatest( ANSWER_HATCH_QUESTION, answerHatchQuestion );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchShareChallenge() {
    yield  takeEvery( SHARE_CHALLENGE_CALENDAR, shareChallengeCalendar );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val: *, type: string}>>}
 */
function* setEventSongs( actionObj ) {
    yield put( setEventSoundSuccess( actionObj.val ) );
};

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchEventSoundValue() {
    yield  takeLatest( SET_CALENDAR_EVENT_AUDIO_VALUE, setEventSongs );
}

function* watchClearHetchData() {
    yield  takeLatest( CLEAR_HATCHGAME_DATA, clearHetchData );
}

function* hatchGameSaga() {
    yield all( [
        watchTimerValue(),
        watchGameProgress(),
        watchShareChallenge(),
        watchEventSoundValue(),
        watchClearHetchData()
    ] );
};

export default hatchGameSaga;
